<template>
  <div>
    <v-container fluid>
      <v-card v-if="item != null" elevation="3">
        <span v-if="item.state != null">
        <v-card-title>
          <v-chip color="info" outlined v-if="item.state == 'SUCCESS'">{{ item.task_id }}</v-chip>
          <v-chip color="error" outlined v-else-if="item.state == 'FAILURE'">{{ item.task_id }}</v-chip>
          <v-chip color="warning" outlined v-else>{{ item.task_id }}</v-chip>
          <v-chip color="info" outlined v-if="item.state == 'SUCCESS'">{{ item.state }}</v-chip>
          <v-chip color="error" outlined v-else-if="item.state == 'FAILURE'">{{ item.state }}</v-chip>
        </v-card-title>
          <v-text-field
            v-if="item.date_done != null"
            dense
            outlined
            label="Date done"
            v-model=item.date_done
            class="mx-4"
            disabled
        >
        </v-text-field>
        <v-text-field
            v-if="item.args != null"
            dense
            outlined
            label="Args"
            v-model=item.args
            class="mx-4"
        >
        </v-text-field>
        <v-text-field
            v-if="item.result != null"
            dense
            outlined
            label="Result"
            v-model=item.result
            class="mx-4"
        >
        </v-text-field>
        <v-textarea
            v-if="item.traceback != null"
            dense
            outlined
            label="Traceback"
            v-model=item.traceback
            class="mx-4"
            rows="20"
        >
        </v-textarea>
          </span>
        <BaseTaskView v-for="child in item.children" :key="child.task_id" :task="child">
        </BaseTaskView>
      </v-card>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'BaseTaskView',
  props: ['taskId', 'task'],

  data() {
    return {
      item: null,
    }
  },

  components: {},

  computed: {},

  methods: {
    async fetchTask() {
      const requestParams = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'credentials': "same-origin",
        },
      };
      const res = await fetch("/site/taskstatus/view/" + this.taskId, requestParams)
      const result = await res.json()
      if (result != null) {
        this.item = result
      } else {
        this.item = null
      }
      console.log(this.item)
    },
  },

  mounted() {
    if (this.taskId != null)
      this.fetchTask()
    else
      this.item = this.task
  },

}
</script>

<style scoped lang="scss">
</style>
